module.exports = __webpack_public_path__ + "img/ic_clear_white_24px.0ce9e32e.svg";